import { render } from "./company-edition.vue?vue&type=template&id=40268e32&ts=true"
import script from "./company-edition.vue?vue&type=script&lang=ts"
export * from "./company-edition.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__